import URLS from "~/api/urls";
import type { LevelCardData, LevelsInfoPayload } from "../model/types";

export const levelsInfoFetchKey = "loadLevelsInfo";
export const archivedLevelsInfoFetchKey = "loadArchivedLevelsInfo";

export function loadLevelsInfo(payload: LevelsInfoPayload): Promise<LevelCardData[]> {
  const locale = {
    lt: "en-lt",
    cy: "en-cy"
  }[payload.countryCode as string];
  const url = URLS.section.levels;
  
  return $fetch(url, {
    method: "POST",
    headers: locale ? { "Content-Language": locale } : {},
    body: { ...payload, isArchivedLevels: payload.isArchivedLevels ?? false },
    signal: payload.controller?.signal
  });
}